import React from "react";
import { Link } from "react-router-dom";
import useMangoLogo from "../images/useMangoLogo.png";
import emailImage from "../images/email.png";

function Footer() {
  return (
    <>
      <footer className="container-fluid bg-grey py-5 mt-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-6 col-12 col-sm-6 mt-2">
              <div className="row">
                <div className=" col-lg-6 col-md-6 col-xs-6 col-12 ">
                  <div className="logo-part">
                    <p>Demo Website for useMango</p>
                    <img src={useMangoLogo} className="w-50" />
                    <p className="mt-2" style={{ color: "#979797" }}>
                      useMango allows you to create Fast. Automated. Codeless. Testing... and that's a F.A.C.T!
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 px-4 col-xs-6 col-12">
                  <h6> About Company</h6>
                  <p style={{ color: "#979797" }}>
                    Since 2002, Infuse Consulting has been helping leading companies deliver their software projects
                    more successfully.
                  </p>
                  <Link to="/contact" className="btn-footer">
                    Contact Us
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-6 col-12 col-sm-6 mt-2">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-xs-6 col-12">
                  <h6> Quick Links</h6>
                  <ul>
                    <li>
                      <Link to="/"> Home</Link>
                    </li>
                    <li>
                      <Link to="/about"> About Us</Link>
                    </li>
                    <li>
                      <Link to="/products"> Products</Link>
                    </li>
                    <li>
                      <Link to="/contact"> Contact</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-lg-6 col-md-6 col-xs-6 col-12">
                  <h6> Reach Us</h6>
                  <ul>
                    <li>
                      <a href="#">Address: Infuse Consulting Ltd Coppergate House 10 Whites Row London E1 7NF</a>
                    </li>
                    <li className="mt-3">
                      <a href="#">Phone: 020 3303 0581</a>
                    </li>
                    <li className="mt-3 d-flex align-items-center">
                      <span>Email:</span>
                      <img src={emailImage} width={180} style={{ margin: "2px 0px 0px 3px" }} />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;
